<div fxFlex="column">
  <div [formGroup]="parts" class="example-tel-input-container">
    <input #inputHours type="number" value="02" min="0" max="{{MAX_HOUR}}" inputrestriction="numbers"
           class="example-tel-input-element" formControlName="hours" size="2" aria-label="hours"
           (change)="onNumericStepper()"
           (input)="_handleInput($event, 'h')"
           (blur)="onBlur()">
    <span class="example-tel-input-spacer">:</span>
    <input #inputMinutes type="number" value="02" min="0" max="59" inputrestriction="numbers"
           class="example-tel-input-element" formControlName="minutes" size="2" aria-label="minutes"
           (change)="onNumericStepper()"
           (input)="_handleInput($event, 'm ')"
           (blur)="onBlur()">
    <span class="example-tel-input-spacer">:</span>
    <input #inputSeconds type="number" min="0" max="59" value="02" inputrestriction="numbers"
           class="example-tel-input-element" formControlName="seconds" size="2" aria-label="seconds"
           (change)="onNumericStepper()"
           (input)="_handleInput($event, 's')"
           (blur)="onBlur()">
  </div>
</div>
